/**
 * Service for area detail operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import { mapAreaDetailFromTransport } from '../mappers';
import type {
  AreaDetail,
  LC_GetCompanyAreaByIdOut,
} from '../types';


export class AreaDetailService {
  /**
   * Get single area by ID
   */
  async getById(areaId: number): Promise<ApiResponse<AreaDetail>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.AREA_BY_ID(areaId);

    const response = await apiClient.get<LC_GetCompanyAreaByIdOut>(endpoint);

    if (response.success && response.data) {
      return {
        ...response,
        data: mapAreaDetailFromTransport(response.data),
      };
    }

    return { ...response, data: null };
  }
}

export const areaDetail = new AreaDetailService();
